import React, { useRef, useContext, useState, useEffect } from "react";
import { FaSync, FaPrint, FaPlus } from "react-icons/fa";
import { Button, Box } from "@chakra-ui/react";
import "./teacher.css"; // Create this file for custom CSS
import List from "./List";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// import { StudentContext } from "../../Context/StudentContext";
import { useNavigate } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";
import axios from "axios";

import { Link } from "react-router-dom";
import Print_pdf_allteachers from "./Print_pdf_allteacher";
import { BASE_URL } from "../../Globalapi/Globalapi";

const TeacherList = () => {
  const navigate = useNavigate();
  // const { students } = useContext(StudentContext);
  const printRef = useRef();
  const [showPrintPdf, setShowPrintPdf] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef(); // Reference to Print_pdf_class_list component

  const [teachers, setTeachers] = useState([]);

  // const handlePrint = async () => {
  //     const input = printRef.current;

  //     try {
  //         const canvas = await html2canvas(input, {
  //             useCORS: true, // Enable cross-origin resource sharing
  //             scale: 2 // Increase scale for higher resolution
  //         });

  //         const imgData = canvas.toDataURL('image/png');

  //         // Initialize jsPDF
  //         const pdf = new jsPDF('portrait', 'mm', 'a4');
  //         const pdfWidth = pdf.internal.pageSize.getWidth();
  //         // const pdfHeight = pdf.internal.pageSize.getHeight();

  //         // Adjust image size and position to fit the page
  //         const imgWidth = pdfWidth;
  //         const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //         pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  //         pdf.save('teacher_list.pdf');
  //     } catch (error) {
  //         console.error('Error during print:', error);
  //     }
  // };

  const handleClick = () => {
    navigate("/teachers/add"); // Navigate to the desired route
  };

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };
  const fetchTeachers = async () => {
    try {
      const jwt = sessionStorage.getItem("jwt"); // If JWT is needed
      const school_id = sessionStorage.getItem('school_id'); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      setTeachers(response.data.data || []);
      setIsDataLoaded(true); // Mark data as loaded

      console.log("Fetched teachers:", response.data);
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setError("Error fetching teachers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  return (
    <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >

          <h1 style={{ fontSize: "20px", margin: 0 }}>Teachers List</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>


            <div className="export-dropdown">
              <Button
                className="export-button"
                display={{ base: "none", md: "flex" }}
                backgroundColor="white"
                fontSize="11px"
                boxShadow="md"
                onClick={handlePrint} // Attach the print handler here
              >
                <FaPrint color="#515B73" />
                Print PDF
              </Button>
            </div>
            <Button
              className="add-teacher-button"
              onClick={handleClick}
              leftIcon={<FaPlus />}
              colorScheme="teal" // Optional: You can customize the color scheme
            >
              <Box display={{ base: "none", md: "block" }}>Add Teacher</Box>
            </Button>
          </div>
        </div>

        <div className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Teachers</span> / <span>All Teachers </span>
        </div>
      </div>

      <div id="teacher-list-content">
        <List />
      </div>

      {/* <div ref={printRef} style={{ display: "none" }}>
                <table className="custom-table">
                    <thead>
                        <tr>
                            <th>Admission Number</th>
                            <th>Name</th>
                            <th>Gender</th>
                            <th>Email</th>
                            <th>DOB</th>
                            <th>Status</th>
                            <th>Class</th>
                        </tr>
                    </thead>
                    <tbody>
                        {students.map((student) => (
                            <tr key={student.admission_number}>
                                <td>{student.admission_number}</td>
                                <td>{student.name}</td>
                                <td>{student.gender}</td>
                                <td>{student.email}</td>
                                <td>{student.date_of_birth}</td>
                                <td>{student.status}</td>
                                <td>{student.class}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div> */}
      <div style={{ display: "none" }}>
        <Print_pdf_allteachers ref={printComponentRef} teachers={teachers} />
      </div>
    </div>
  );
};

export default TeacherList;
